"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var TabHead_1 = __importDefault(require("./TabHead"));
var getCSSRules = function (_a, _b) {
    var colors = _a.colors;
    var align = _b.align, hideBottomBorder = _b.hideBottomBorder;
    return ({
        tabHeads: {
            userSelect: 'none',
            padding: '0 8px',
            marginBottom: 30,
            borderBottom: "1px solid ".concat(hideBottomBorder ? 'transparent' : colors.Grey[200]),
            display: 'flex',
            justifyContent: align === 'center' ? 'center' : align === 'left' ? undefined : 'flex-end',
        },
    });
};
var Tabs = function (props) {
    var children = props.children, defaultTab = props.defaultTab, onChange = props.onChange, classNames = props.classNames;
    var theme = (0, react_1.useTheme)();
    var _a = classNames || {}, wrapper = _a.wrapper, tabHeadItem = _a.tabHeadItem, tabHeads = _a.tabHeads;
    var styles = getCSSRules(theme, props);
    var _b = (0, react_2.useState)(defaultTab), active = _b[0], setActive = _b[1];
    (0, react_2.useEffect)(function () {
        props.current !== undefined && handleTabClick(props.current);
    }, [props.current]);
    var tabs = (0, react_2.useMemo)(function () {
        return react_2.Children.map(children, function (child, index) {
            if (!(0, react_2.isValidElement)(child))
                return;
            var _a = child.props, label = _a.label, badge = _a.badge, _b = _a.id, id = _b === void 0 ? index : _b;
            var component = (0, react_2.cloneElement)(child, { active: index === active });
            return { label: label, badge: badge, id: id, component: component };
        });
    }, [children, active]);
    var handleTabClick = function (index) {
        if (index !== active) {
            setActive(index);
            onChange && onChange(index);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: wrapper }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ css: styles.tabHeads, className: tabHeads }, { children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (_a, index) {
                    var label = _a.label, badge = _a.badge, id = _a.id;
                    return ((0, jsx_runtime_1.jsx)(TabHead_1.default, { className: tabHeadItem, onClick: function () { return !props.disabled && handleTabClick(index); }, label: label, badge: badge, active: index === active }, id));
                }) }), void 0), (0, jsx_runtime_1.jsx)("div", { children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (_a) {
                    var component = _a.component, id = _a.id;
                    return ((0, jsx_runtime_1.jsx)("div", { children: component }, id));
                }) }, void 0)] }), void 0));
};
Tabs.defaultProps = {
    defaultTab: 0,
    align: 'left',
};
var Tab_1 = require("./Tab");
Object.defineProperty(exports, "Tab", { enumerable: true, get: function () { return __importDefault(Tab_1).default; } });
exports.default = Tabs;
//# sourceMappingURL=index.js.map